var render = function render(){var _vm=this,_c=_vm._self._c;return _c('materials',{attrs:{"show-export-xls":false,"show-client-selection":true,"need-client-id":false,"show-county-paramedic-tab":false,"show-import-btn":true},on:{"loadCategories":_vm.loadAdminCategories,"loadDocuments":_vm.loadAdminDocuments,"exportDocuments":_vm.exportAdminDocuments}})
}
var staticRenderFns = []

export { render, staticRenderFns }